export const statusOptions = [
  { label: "Aktif", value: 1 },
  { label: "Pasif", value: 0 },
];

export const SORT_OPTIONS = [
  {
    value: "APPLICANT_COUNT_ASC",
    label: "Başvuru Sayısı (Artan)",
    orderBy: "APPLICANT_COUNT",
    direction: "asc",
  },
  {
    value: "APPLICANT_COUNT_DESC",
    label: "Başvuru Sayısı (Azalan)",
    orderBy: "APPLICANT_COUNT",
    direction: "desc",
  },
  {
    value: "LOCATION_ASC",
    label: "Konum (A-Z)",
    orderBy: "LOCATION",
    direction: "asc",
  },
  {
    value: "LOCATION_DESC",
    label: "Konum (Z-A)",
    orderBy: "LOCATION",
    direction: "desc",
  },
  {
    value: "ADVERT_START_DATE_ASC",
    label: "İlan Tarihi (Eskiden Yeniye)",
    orderBy: "ADVERT_START_DATE",
    direction: "asc",
  },
  {
    value: "ADVERT_START_DATE_DESC",
    label: "İlan Tarihi (Yeniden Eskiye)",
    orderBy: "ADVERT_START_DATE",
    direction: "desc",
  },
];
